<template>
  <dv-decoration-1 class="decoration-container" :color="color"></dv-decoration-1>
</template>
<script>
import { decoration1 } from '@jiaminghi/data-view'
import Vue from 'vue'
import Minin from './mixin'
Vue.use(decoration1)
export default {
  name: 'Decoration1',
  mixins: [Minin]
}
</script>
<style lang="less" scoped>
  .decoration-container{
    width: 100%;
    height: 100%;
  }
</style>